import React from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import Seo from "../../components/Seo";
import ChatConversation from "./ChatConversation";

// A client's service chat, opened from My Clients. Full-width conversation;
// full-screen on phones like the regular chat.
const LawyerServiceChat = () => {
  const { chatId } = useParams();
  const navigate = useNavigate();
  const { refreshProfile } = useOutletContext();

  return (
    <div className="lwp-chat-layout has-open lwp-service-chat">
      <Seo title="Client Chat | Legal Platform" noindex />
      <section className="lwp-chat-pane">
        <ChatConversation
          key={chatId}
          chatId={chatId}
          onBack={() => navigate(-1)}
          onActivity={() => refreshProfile()}
        />
      </section>
    </div>
  );
};

export default LawyerServiceChat;
